import Vue from 'vue'
import Router from 'vue-router'
//首页
import index from "../components/index"; //
//基础数据
import bridge from "../components/basicData/bridge"; //首页
import joinUs from "../components/basicData/joinUs"; //人才招聘
import company from "../components/basicData/company"; //公司简介
import newsList from "../components/basicData/newsList"; //新闻列表
import newsCont from "../components/basicData/newsCont"; //新闻详情
import sysinfo from "../components/basicData/sysinfo"; //系统详情
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default new Router({
    routes: [{
        path: "/",
        name: "index",
        component: index,
        children: [
            //桥梁
            {
                path: "/",
                name: "bridge",
                component: bridge
            },
            //桥梁
            {
                path: "/index",
                name: "bridge",
                component: bridge
            }
        ]
    }, {
        path: "/joinUs",
        name: "joinUs",
        component: joinUs,
    }, {
        path: "/company",
        name: "company",
        component: company,
    }, {
        path: "/sysinfo",
        name: "sysinfo",
        component: sysinfo,
    }, {
        path: "/newsList",
        name: "newsList",
        component: newsList,
    }, {
        path: "/newsCont",
        name: "newsCont",
        component: newsCont,
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js